import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LinearProgress } from '@mui/material';

const theme = createTheme({
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#d3d3d3', // Track color
        },
        bar: {
          backgroundColor: '#71CA9B', // Progress bar color
        },
      },
    },
  },
});

function Progressbar({value}) {
  const barColor = value === 0 ? '#d3d3d3' : '#71CA9B';
  return (
    <ThemeProvider theme={theme}>
      <LinearProgress variant="determinate" value={value} sx={{ width: '99%', maxWidth: '98px', borderRadius: '8px', '& .MuiLinearProgress-bar': {
            backgroundColor: barColor, 
          },}}/>
    </ThemeProvider>
  );
}

export default Progressbar;
